<template>
    <v-bottom-sheet
            v-model="bottomSheet"
            max-width="80%"
            v-on:click:outside="setTableScale">
        <template v-slot:activator="{ on }">
            <v-btn large color="primary" v-on="on">Select Columns</v-btn>
        </template>
        <v-card>
            <v-card-title>
                Select Columns
            </v-card-title>
            <v-card-text>
                <select multiple="true"
                        v-model="activeCols"
                        ref="columnSelect"
                        class="hidden">
                    <option v-for="column in availableColumns"
                            v-bind:value="column">{{column}}
                    </option>
                </select>
                <div id="column-selector">
                    <v-switch
                        color="primary"
                        v-for="column in availableColumns"
                        :label="column"
                        :input-value="activeCols.includes(column)"
                        :key="column"
                        v-on:mouseenter="setFocusColumn(column)"
                        v-on:mouseleave="setFocusColumn(false)"
                        v-on:change="triggerSelect(column)"></v-switch>
                </div>
            </v-card-text>
        </v-card>
    </v-bottom-sheet>
</template>
<script>
    export default {
        name: 'eps-column-selector',
        props: {
            activeColumns: Array,
            availableColumns: Array,
            columnSelector: Boolean,
            container: {}
        },
        data () {
            return {
                bottomSheet: this.columnSelector,
                activeCols: this.activeColumns
            }
        },
        methods: {
            setFocusColumn(val) {
                this.$emit('focus-column', val);
            },
            triggerSelect(val) {
                let select = this.$refs.columnSelect;
                let option = select.querySelector(`option[value="${val}"]`);
                option.selected = !option.selected;
                select.dispatchEvent(new Event('change'));
                this.setFocusColumn(this.activeCols.includes(val) ? val : false);
                this.$emit('set-column', this.activeCols);
            },
            setTableScale() {
                let container = this.container;
                let table = container.querySelector('table');
                this.scale = Math.min(
                    container.offsetWidth / table.offsetWidth,
                    container.offsetHeight / table.offsetHeight
                );
                table.style.transform = this.bottomSheet ? `scale(${this.scale})` : 'scale(1)';
            }
        },
        watch: {
            bottomSheet: function() {
                this.setTableScale();
                this.$emit('launch', this.bottomSheet);
            },
            activeCols: function() {
                setTimeout(this.setTableScale, 25);
            }
        }
    }
</script>
<style>
    #column-selector {
        display: flex;
        flex-wrap: wrap;
        padding: 15px;
    }

    #column-selector .v-input label {
        margin-top: 7px;
    }

    .hidden {
        opacity: 0;
        visibility: hidden;
        display: none;
    }

    #column-selector .v-input {
        justify-content: center;
        align-items: start;
        flex-basis: 160px;
    }

    #column-selector .v-input__slot {
        flex-direction: column;
        margin: 0 5px;
        text-align: center;
    }
</style>